export default __webpack_public_path__ + "static/media/collection.15d51bf6.svg";